import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HttpError } from '../models/http-errors.model';

@Injectable({
  providedIn: 'root'
})

// Global HTTP Handlers for all the errors which occurs at the front end.
export class HttpErrorInterceptor implements HttpInterceptor {
  // global varilable declartions

  constructor(private toasterService: ToastrService,
              private router: Router,
  ) { }

  // toaster service for displaying Error Msg at Top Right.
  public get toast(): ToastrService {
    return this.toasterService;
  }
  public set toast(value: ToastrService) {
    this.toasterService = value;
  }

  // DO NOT MODIFY THIS CODE; Shows the all the HTTP Error msg and displays approriate msg to the user as well;
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const logFormat = 'background: maroon; color: white';

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        switch (error.status) {
          // Start all the HTTP error handling.
          case HttpError.BadRequest:
            console.error('%c Bad Request 400', logFormat);
            this.toasterService.error('Error! Please try again.');
            break;

          case HttpError.Unauthorized:
            console.error('%c Unauthorized 401', logFormat);
            this.toasterService.error('Unauthorized access! Please login again.');
            this.router.navigate(['/login']);
            break;

          case HttpError.NotFound:
            console.error('%c Not Found 404', logFormat);
            this.toasterService.error('Error! Please try again.');
            break;

          case HttpError.UnprocessableEntity:
            console.error('%c Unprocessable Entity 422', logFormat);
            this.toasterService.error('Error! Please try again.');
            break;

          case HttpError.TimeOut:
            console.error('%c TimeOut 408', logFormat);
            this.toasterService.error('Timeout error! Please login again.');
            this.router.navigate(['/login']);
            break;

          case HttpError.Forbidden:
            console.error('%c Forbidden 403', logFormat);
            this.toasterService.error('Not authorized to view the current page! Please try again.');
            this.router.navigate(['/login']);
            break;

          case HttpError.InternalServerError:
            console.error('%c Internal Server Error 500', logFormat);
            this.toasterService.error('Error occurred! Please try again or Please contact system administrator.');
            this.router.navigate(['/user']);
            break;
            // End all the HTTP error handling.

          default:
            // COMMENT THIS CODE BFFORE MOVING TO QA/STG/PRODUCTION; sshanubhog;
            this.toasterService.error(`API has responded with a ${error.status} error.\n ${error.message}`, `HTTP ERROR`);
        }
        return throwError(error);
      })
    );
  }
}
